var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 6.66675C8.15817 6.66675 6.6665 8.15841 6.6665 10.0001C6.6665 11.8417 8.15817 13.3334 9.99984 13.3334C11.8415 13.3334 13.3332 11.8417 13.3332 10.0001C13.3332 8.15841 11.8415 6.66675 9.99984 6.66675ZM9.99984 11.6667C9.08317 11.6667 8.33317 10.9167 8.33317 10.0001C8.33317 9.08341 9.08317 8.33341 9.99984 8.33341C10.9165 8.33341 11.6665 9.08341 11.6665 10.0001C11.6665 10.9167 10.9165 11.6667 9.99984 11.6667Z",
    fill: "#1E293B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7167 4.85005L11.675 2.60839C11.15 2.31672 10.575 2.17505 10 2.17505C9.425 2.17505 8.84166 2.31672 8.32499 2.60839L4.28335 4.85005C3.18335 5.45839 2.5 6.61671 2.5 7.87505V12.1251C2.5 13.3834 3.18335 14.5417 4.28335 15.15L8.32499 17.3917C8.84999 17.6834 9.425 17.825 10 17.825C10.575 17.825 11.1583 17.6834 11.675 17.3917L15.7167 15.15C16.8167 14.5417 17.5 13.3834 17.5 12.1251V7.87505C17.5 6.61671 16.8167 5.45839 15.7167 4.85005ZM15.8333 12.1251C15.8333 12.7751 15.4833 13.375 14.9083 13.6917L10.8667 15.9334C10.6 16.0834 10.3 16.1584 10 16.1584C9.7 16.1584 9.39166 16.0834 9.13333 15.9334L5.09165 13.6917C4.52499 13.375 4.16667 12.7751 4.16667 12.1251V7.87505C4.16667 7.22505 4.51665 6.62505 5.09165 6.30839L9.13333 4.06672C9.39999 3.91672 9.7 3.84172 10 3.84172C10.3 3.84172 10.6083 3.91672 10.8667 4.06672L14.9083 6.30839C15.475 6.62505 15.8333 7.22505 15.8333 7.87505V12.1251Z",
    fill: "#1E293B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.d759314ee06d2fc8eaaf269b5e859fc2.svg";
export { ForwardRef as ReactComponent };